module.exports = __webpack_public_path__ + "img/boss_right.d17fe714.jpg";